document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll('.custom-cta-button');

  buttons.forEach(button => {
    button.addEventListener('click', (e) => {
      button.classList.add('clicked');

      // Optional: Remove after a delay
      setTimeout(() => {
        button.classList.remove('clicked');
      }, 300); // 300ms
    });
  });
});
